import { FormControl, AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomFormValidatorHelper {

    public static noWhitespace(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true }
    }

    public static minLengthArray(min: number) {
        return (c: AbstractControl): { [key: string]: any } => {
            if (c.value.filter(t => t).length >= min) {
                return null;
            }
            return { 'minLengthArray': { valid: false, minRequired: min } };
        }
    }

  public static isSchemaValid(inputControl: AbstractControl) {
    try {
      JSON.parse(inputControl.value);
      return null;
    } catch (ex) {
      return { 'schemaInValid': { value: inputControl.value } };
    }
  }
}
